import { render, staticRenderFns } from "./CovidInformation.vue?vue&type=template&id=171c0757"
import script from "./CovidInformation.vue?vue&type=script&lang=js"
export * from "./CovidInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports